import React from "react";
import "./PcaFounder.css";
import founderImg from "../../assets/images/founder.jpg";

const stats = [
  { value: "1,200+", label: "consecutive issues" },
  { value: "0", label: "missed sends" },
  { value: "15,000+", label: "auction results" }
];

function PcaFounder() {
  return (
    <section className="founder-section" id="founder">
      <div className="founder__inner">
        <img
          className="founder__photo"
          src={founderImg}
          alt="David Whitlock, founder of Bidder iQ"
        />
        <div className="founder__content">
          <div className="founder__eyebrow">Who Built This</div>
          <h2 className="founder__headline">
            Built by the writer of Stuttgart Market Letter
          </h2>
          <p className="founder__text">
            I'm David Whitlock. Since October 2022, I've written
            Stuttgart Market Letter: over 1,200 consecutive issues on Porsche auctions. Bidder iQ is the tool I built
            from everything I learned about which data actually moves price.
          </p>
          <div className="founder__stats">
            {stats.map((stat) => (
              <div className="founder__stat" key={stat.label}>
                <div className="founder__stat-value">{stat.value}</div>
                <div className="founder__stat-label">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default PcaFounder;
